export const DRAWER_WIDTH = 240;
export const TOP_APP_BAR_HEIGHT = 64;

export const PROJECT_PATH = '/project/:projectId';
export const OUTREACH_HOME_PATH = `/outreach`;
export const OUTREACH_EDITOR_PATH = `/editor`;
